function buildAuthConfig(token) {
  return {
    headers: {
      Authorization: token,
    },
  }
}

function getApiBase() {
  return `${process.env.VUE_APP_API_URL}/companies/context`
}

export async function fetchCurrentCompanyContext(client, token) {
  const response = await client.get(
    `${getApiBase()}/current`,
    buildAuthConfig(token),
  )
  return normalizeCurrentCompanyContextResponse(response.data)
}

// Story 17.8
export async function fetchAdminContextView(client, token) {
  const response = await client.get(
    `${getApiBase()}/admin`,
    buildAuthConfig(token),
  )
  return response.data?.adminContextView || null
}

// Story 17.8
export async function submitContextAmendment(client, token, { fieldPath, note }) {
  const response = await client.post(
    `${getApiBase()}/amendments`,
    { fieldPath, note },
    buildAuthConfig(token),
  )
  return response.data?.amendment || null
}

// Story 28.1
export async function fetchCompanyContextHistory(client, token) {
  const response = await client.get(
    `${getApiBase()}/history`,
    buildAuthConfig(token),
  )
  return response.data?.versions || []
}

// Story 28.1
export async function fetchCompanyContextDiff(client, token, { from, to }) {
  const response = await client.get(`${getApiBase()}/history/diff`, {
    ...buildAuthConfig(token),
    params: { from, to },
  })
  return response.data?.diff || null
}

// Story 28.2
export async function fetchCompanyContextDimensionDiff(client, token, { from, to }) {
  const response = await client.get(`${getApiBase()}/history/diff/dimensions`, {
    ...buildAuthConfig(token),
    params: { from, to },
  })
  return response.data?.diff || null
}

export function normalizeApprovedContextResponse(payload) {
  if (!payload) return null

  return {
    companyContextId: payload.companyContextId,
    version: payload.version,
    status: payload.status,
    approvalState: payload.approvalState || 'approved',
    // Story 17.8 — distinguishes a manually-saved context from a nightly-inferred one so
    // BusinessContext.vue can branch to the admin context view.
    source: payload.source || 'manual',
    draft: payload.draft,
    summary: payload.summary,
    approvedAt: payload.approvedAt || new Date().toISOString(),
    createdAt: payload.createdAt || new Date().toISOString(),
    updatedAt: payload.updatedAt || new Date().toISOString(),
    progress: payload.progress || null,
  }
}

export function normalizeCurrentCompanyContextResponse(payload) {
  if (!payload) return null

  if (payload.companyContext === null) {
    return { companyContext: null }
  }

  if (payload.companyContext) {
    return {
      ...payload,
      companyContext: normalizeApprovedContextResponse(payload.companyContext),
    }
  }

  if (payload.companyContextId || payload.summary || payload.draft) {
    return {
      companyContext: normalizeApprovedContextResponse(payload),
    }
  }

  return payload
}
